var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "knowledgeSet-container" },
    [
      _c(
        "div",
        { staticClass: "filter-area" },
        [
          _c("el-input", {
            staticStyle: { width: "180px", "margin-right": "10px" },
            attrs: {
              placeholder: "输入知识集名称搜索",
              "suffix-icon": "el-icon-search",
              size: "mini",
              clearable: ""
            },
            on: { blur: _vm.searchFn, clear: _vm.searchFn },
            model: {
              value: _vm.formData.kbName,
              callback: function($$v) {
                _vm.$set(_vm.formData, "kbName", $$v)
              },
              expression: "formData.kbName"
            }
          }),
          _c(
            "el-select",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingC,
                  expression: "loadingC"
                }
              ],
              staticStyle: { width: "200px" },
              attrs: {
                size: "mini",
                placeholder: "选择创建人筛选",
                clearable: ""
              },
              on: { change: _vm.searchFn },
              model: {
                value: _vm.formData.createName,
                callback: function($$v) {
                  _vm.$set(_vm.formData, "createName", $$v)
                },
                expression: "formData.createName"
              }
            },
            _vm._l(_vm.optionsCreateName, function(item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.label, value: item.value }
              })
            }),
            1
          ),
          _c(
            "el-button",
            {
              staticStyle: { float: "right" },
              attrs: { type: "primary", size: "mini" },
              on: {
                click: function($event) {
                  return _vm.openPopup("add")
                }
              }
            },
            [_vm._v("创建知识集")]
          )
        ],
        1
      ),
      _c(
        "div",
        { ref: "tableWrapper", staticClass: "table-area" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              ref: "singleTable",
              staticStyle: {
                width: "100%",
                height: "100%",
                "font-size": "13px"
              },
              attrs: {
                height: _vm.tableHeight,
                size: "medium",
                "header-cell-style": {
                  background: "#eef1f6",
                  color: "#606266"
                },
                "highlight-current-row": true,
                data: _vm.tableData
              }
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "65", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.formData.size * (_vm.formData.page - 1) +
                                (scope.$index + 1)
                            ) +
                            " "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "kbName",
                  label: "知识集名称",
                  "show-overflow-tooltip": true
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "kbId",
                  label: "知识集ID",
                  "show-overflow-tooltip": true
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.status == 0
                          ? _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v("停用")
                            ])
                          : scope.row.status == 1
                          ? _c(
                              "span",
                              { staticStyle: { color: "rgb(3, 177, 3)" } },
                              [_vm._v("启用")]
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { prop: "num", label: "文件数量", width: "160" }
              }),
              _c("el-table-column", {
                attrs: { prop: "createTime", label: "创建时间", width: "220" }
              }),
              _c("el-table-column", {
                attrs: { prop: "creatorName", label: "创建人", width: "160" }
              }),
              _c("el-table-column", {
                attrs: { prop: "operation", label: "操作", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function($event) {
                                return _vm.openPopup("edit", scope.row)
                              }
                            }
                          },
                          [_vm._v("编辑")]
                        ),
                        scope.row.status == 0
                          ? _c(
                              "el-button",
                              {
                                staticStyle: { color: "orange" },
                                attrs: { type: "text" },
                                on: {
                                  click: function($event) {
                                    return _vm.openPopup("use", scope.row)
                                  }
                                }
                              },
                              [_vm._v("启用")]
                            )
                          : _vm._e(),
                        _c(
                          "el-button",
                          {
                            staticStyle: { color: "red" },
                            attrs: { type: "text" },
                            on: {
                              click: function($event) {
                                return _vm.deleteRow(scope.row)
                              }
                            }
                          },
                          [_vm._v("删除")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "staff-pagination" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.formData.page,
              "page-size": _vm.formData.size,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
              "page-sizes": [20, 50, 100, 200, 500]
            },
            on: {
              "current-change": _vm.searchFn,
              "size-change": _vm.searchFn,
              "update:currentPage": function($event) {
                return _vm.$set(_vm.formData, "page", $event)
              },
              "update:current-page": function($event) {
                return _vm.$set(_vm.formData, "page", $event)
              },
              "update:pageSize": function($event) {
                return _vm.$set(_vm.formData, "size", $event)
              },
              "update:page-size": function($event) {
                return _vm.$set(_vm.formData, "size", $event)
              }
            }
          })
        ],
        1
      ),
      _vm.showAddEditPopup
        ? _c("addEditPopup", {
            attrs: {
              currentRow: _vm.rowPopup,
              dialogVisible: _vm.showAddEditPopup,
              currentPopupType: _vm.currentPopupType,
              titleName: _vm.popupTitle
            },
            on: {
              "update:dialogVisible": function($event) {
                _vm.showAddEditPopup = $event
              },
              "update:dialog-visible": function($event) {
                _vm.showAddEditPopup = $event
              },
              getData: _vm.searchFn
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }